import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Challenge from './views/Challenge.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        section: 'home'
      },
      component: Home
    },
    {
      path: '/challenge/:number',
      name: 'challenge',
      meta: {
        section: 'challenge'
      },
      component: Challenge,
      props: true
    },
    {
      path: '/challenge/:number/:view',
      name: 'challenge_view',
      meta: {
        section: 'challenge'
      },
      component: Challenge,
      props: true
    }
  ]
})

window.addEventListener('hashchange', function () {
  parent.postMessage('resize')
})

export default router
